import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import FormItem from './formitem.js';

export default class Announcements extends React.Component
{
    constructor(props)
    {
        super(props);
        this.createAnnouncementClick = this.createAnnouncementClick.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.startDateChanged = this.startDateChanged.bind(this);
        this.endDateChanged = this.endDateChanged.bind(this);
        this.inputChanged = this.inputChanged.bind(this);
        this.state = {
            loaded: false,
            errorMessage: "",
            create: false,
            submissionAttempted: false,
            formData: {
                startDate: moment(),
                endDate: moment(),
                announcementText: "",
                announcementID: 0,
                level: 0
            },
            announcements: [],
            validationErrors: []
        }
    }
    componentDidMount()
    {
        this.loadAnnouncements();
    }
    loadAnnouncements()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Announcement",
            action: "GetAnnouncements",
            method: "get",
            success: (response) =>
            {
                this.setState({loaded: true, announcements: response.announcements})
            },
            error: (err) =>
            {
                this.setState({loaded: true, errorMessage: "An error occurred while loading announcements. Please try again later."})
            }
        })
    }
    createAnnouncementClick(event)
    {
        event.preventDefault();
        this.setState({create: true});
    }
    cancelClick(event)
    {
        this.setState({
            loaded: true, 
            create: false,
            errorMessage: "",
            formData: {
                startDate: moment(),
                endDate: moment(),
                announcementText: "",
                announcementID: 0,
                level: 0
            }
        });
    }
    editClick(event, announcementID)
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Announcement",
            action: "GetAnnouncement",
            method: "post",
            body: JSON.stringify({announcementID: announcementID}),
            success: (result) => {
                if (result.announcementID === 0)
                {
                    this.setState({loaded: true, errorMessage: "An error occurred while fetching the announcement for editing."});
                    return;
                }
                this.setState({
                    loaded: true,
                    create: true,
                    errorMessage: "",
                    formData: {
                        announcementID: result.announcementID,
                        startDate: moment(result.startDate),
                        endDate: moment(result.endDate),
                        announcementText: result.announcementText,
                        level: result.level
                    }
                })
            },
            error: (err) => {
                this.setState({loaded: true, errorMessage: "An error occurred while fetching the announcement for editing."})
            }
        })
    }
    deleteClick(event, announcementID)
    {
        if (window.confirm("Are you sure you want to delete this announcement?"))
        {
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Announcement",
                action: "DeleteAnnouncement",
                method: "post",
                body: JSON.stringify({announcementID: announcementID}),
                success: (result) => {
                    this.setState({
                        loaded: true, 
                        create: false,
                        errorMessage: "",
                        formData: {
                            startDate: moment(),
                            endDate: moment(),
                            announcementText: "",
                            announcementID: 0,
                            level: 0
                        }
                    }, this.loadAnnouncements());
                },
                error: (err) => {
                    this.setState({loaded: true, errorMessage: "An error occurred while deleting this announcement."})
                }
            })
        }
    }
    validate()
    {
        if (this.state.submissionAttempted)
        {
            var errors = [];
            if (this.state.formData.startDate === null)
            {
                errors.push({message: "Start date is required.", element: "startDate"});
            }
            if (this.state.formData.endDate === null)
            {
                errors.push({message: "End date is required.", element: "endDate"});
            }
            if (this.state.formData.announcementText === "")
            {
                errors.push({message: "Announcement text is required.", element: "announcementText"});
            }
            this.setState({validationErrors: errors});
            if (errors.length >0)
            {
                return false;
            }
        }
        return true;
    }
    inputChanged(event)
    {
        var data = this.state.formData;
        data[event.target.name] = event.target.value;
        console.dir(data);
        this.setState({formData: data}, () => this.validate());
    }
    startDateChanged(event)
    {
        var data = this.state.formData;
        data.startDate = event;
        this.setState({formData: data}, () => this.validate());
    }
    endDateChanged(event)
    {
        var data = this.state.formData;
        data.endDate = event;
        this.setState({formData: data}, () => this.validate());
    }
    submitAnnouncement(event)
    {
        event.preventDefault();
        this.setState({submissionAttempted: true}, () => {
            if (this.validate())
            {
                console.log(this.state.formData.startDate.toString());
                this.setState({loaded: false});
                this.props.api.send({
                    controller: "Announcement",
                    action: "SaveAnnouncement",
                    method: "post",
                    body: JSON.stringify(this.state.formData),
                    success: (result) => {
                        if (result.success)
                        {
                            this.setState({
                                loaded: true, 
                                create: false,
                                errorMessage: "",
                                formData: {
                                    startDate: moment(),
                                    endDate: moment(),
                                    announcementText: "",
                                    announcementID: 0,
                                    level: 0
                                }
                            });
                            this.loadAnnouncements();
                        }
                        else
                        {
                            this.setState({loaded: true, errorMessage: result.message});
                        }
                    },
                    error: (err) => {
                        this.setState({loaded: true, errorMessage: "An error occurred while saving this announcement. Please try again later"});
                    }
                });
            }  
        })
    }
    render()
    {
        const levels = [
            {value: 0, name: "Informational"},
            {value: 1, name: "Warning"},
            {value: 2, name: "Critical"}
        ]
        const announcementrows = this.state.announcements.map((a) =>
            <tr key={a.announcementID}>
                <td>
                    {a.announcementText.length >= 280 ? 
                        a.announcementText.substring(0, 199) + "..." : a.announcementText}
                </td>
                <td>{moment(a.startDate).format("MM/DD/YYYY HH:mm")}</td>
                <td>{moment(a.endDate).format("MM/DD/YYYY HH:mm")}</td>
                <td>
                    {levels.map((l) => {return l.value === a.level ? l.name : null})}
                </td>
                <td style={{width: "155px"}}>
                    <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.editClick(e, a.announcementID)}}>Edit</a>
                    <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.deleteClick(e, a.announcementID)}}>Delete</a>
                </td>
            </tr>
        )
        return (
            <div className="lmsdisplayarea">
                <h3>Announcements</h3>
                {this.state.loaded ? (
                    <div>
                        <Link className="lmsbutton" to="/" onClick={this.createAnnouncementClick}>Create Announcement</Link>
                        {this.state.create ? (
                            <div>
                                <div className="lmsvalidationerror">
                                    {this.state.errorMessage}
                                </div>
                                <div className="lmsform">
                                    <div className="lmsformheading">
                                        {this.state.formData.announcementID === 0 ? 
                                            "New Announcement" : "Edit Announcement"
                                        }
                                    </div>
                                    <div className="lmsformbody">
                                        <form className="lmsforminner" method="post" onSubmit={(e) => this.submitAnnouncement(e)}>
                                            <FormItem label="Start Date:" name="startDate" type="datetimestart"
                                                inputChanged={this.startDateChanged}
                                                startDate={this.state.formData.startDate} endDate={this.state.formData.endDate} />
                                            <FormItem label="End Date:" name="endDate" type="datetimeend"
                                                inputChanged={this.endDateChanged} 
                                                startDate={this.state.formData.startDate} endDate={this.state.formData.endDate } />
                                            <FormItem label="Announcement:" name="announcementText" type="textarea"
                                                inputChanged={this.inputChanged} value={this.state.formData.announcementText}
                                                validationErrors={this.state.validationErrors} />
                                            <FormItem label="Importance:" name="level" type="radiobuttons"
                                                inputChanged={this.inputChanged} options={levels} value={this.state.formData.level} />
                                            <div className="lmsvalidationerror">
                                                <span>{this.state.validationErrors.map((err) =>
                                                    <p key={err.element}>{err.message}</p>
                                                )}</span>
                                            </div>
                                            <div className="lmsformfooter">
                                                <input type="button" name="cancel" value="Cancel" className="lmsbutton" onClick={this.cancelClick} />
                                                <input type="submit" name="save" value="Save" className="lmsbutton" />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {this.state.announcements.length === 0 ? (
                            <div>There are currently no announcements.</div>
                        ) : (
                            <div className="lmstablecontainer">
                                <table className="lmstable">
                                    <thead>
                                        <tr>
                                            <th>Announcement</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Importance</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {announcementrows}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/general/announcements.js